import Range from "./Range";
const navCornerIds = ["Header", "Show", "Size", "Blank"];

const utils = (context) => {};

const main = (context) => {
  const { dispatch, rootState, rootGetters, current } = context;
  return {
    showNavigationCorner() {
      dispatch("views/changeValues", { ids: navCornerIds, key: "show", value: "1", dimension: "rows" }, { root: true });
      dispatch(
        "views/changeValues",
        { ids: navCornerIds, key: "show", value: "1", dimension: "columns" },
        { root: true }
      );
      dispatch("cells/toggleRedrawCanvas", null, { root: true });
      return () => {
        this.hideNavigationCorner();
      };
    },
    hideNavigationCorner() {
      dispatch("views/changeValues", { ids: navCornerIds, key: "show", value: "0", dimension: "rows" }, { root: true });
      dispatch(
        "views/changeValues",
        { ids: navCornerIds, key: "show", value: "0", dimension: "columns" },
        { root: true }
      );
      // update range selection in case active range selection is within hidden columns and rows
      const mainRange = rootState.cells.formulaRanges[0]?.range;
      const firstVisibleColumnIndex = current.design.columns.findIndex((item) =>
        rootGetters["cells/getColumnVisibility"](item.id)
      );
      const firstVisibleRowIndex = current.design.rows.findIndex((item) =>
        rootGetters["cells/getRowVisibility"](item.id)
      );
      if (mainRange && (mainRange[0] < firstVisibleColumnIndex || mainRange[1] < firstVisibleRowIndex))
        Range(context).utils.focusFirstVisibleCell();
      dispatch("cells/toggleRedrawCanvas", null, { root: true });

      return () => {
        this.showNavigationCorner();
      };
    },
  };
};
export default (context) => {
  return {
    main: main(context),
    utils: utils(context),
  };
};
